import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import Cart from './Cart';
import CheckoutSection from './components/CheckoutSection';


//if( document.getElementById('CartReactJS')!==null ) ReactDOM.render(<Cart ref={(Cart) => {window.CartReactJS = Cart}} />, document.getElementById('CartReactJS'));

if( document.getElementById('CartReactJS')!==null ){
	window.CartReactJS = ReactDOM.createRoot(document.getElementById('CartReactJS'));
	window.CartReactJS.render(<Cart ref={(Cart) => {window.CartReactJS = Cart}} />);
}

if( document.getElementById('CheckoutSection')!==null ){
	window.CheckoutSection = ReactDOM.createRoot(document.getElementById('CheckoutSection'));
	window.CheckoutSection.render(<CheckoutSection ref={(CheckoutSection) => {window.CheckoutSection = CheckoutSection}} />);
}



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
